import RSwitch from '../../../ui/inputs/RSwitch';
import { SubRedPanelView } from './subscriptionsRedemptions.types';
import { SUB_RED_PANEL_CONFIG } from './utils/subRedPanelViews';

interface SubRedViewToggleProps<T extends SubRedPanelView> {
  value: T;
  options: T[];
  onChange: (view: T) => void;
}

const SubRedViewToggle = <T extends SubRedPanelView>({
  value,
  options,
  onChange,
}: SubRedViewToggleProps<T>) => {
  const offView = options[0];
  const onView = options[1];
  if (!offView || !onView) {
    return null;
  }
  const enabled = value === onView;

  return (
    <RSwitch
      enabled={enabled}
      setEnabled={(checked) => onChange(checked ? onView : offView)}
      label={SUB_RED_PANEL_CONFIG[offView].toggleLabel}
      labelOn={SUB_RED_PANEL_CONFIG[onView].toggleLabel}
      wrapperClassName="my-0"
    />
  );
};

export const SubRedPanelHeader = <T extends SubRedPanelView>({
  title,
  view,
  views,
  onViewChange,
}: {
  title: string;
  view: T;
  views: T[];
  onViewChange: (view: T) => void;
}) => {
  return (
    <div className="flex min-h-12 items-center justify-between px-4 pt-2">
      <h2 className="text-xl font-normal text-mainblue">{title}</h2>
      <SubRedViewToggle value={view} options={views} onChange={onViewChange} />
    </div>
  );
};

export default SubRedViewToggle;
